// import api from './appApi';
import Notify from './notify';
import {CartValidationRequest} from "../public/checkout/request/cartValidationRequest";
import {
	dispatchValidateCartItems,
	getCartItemsFromStorage,
} from '../public/swiss_ui/cart/Cart';

/**
 * Abstract
 * Base cart validation class, used for checkout & cart validation
 */
class BaseCheckoutItemsValidator {
	/**
	 * Constructor
	 */
	constructor() {
		this.notifier = new Notify();
		this.registerEventListeners();
		return this;
	}

	registerEventListeners() {
		// Following Events will be dispatch from Cart or from this File to validate Cart Items
		document.addEventListener('validateCartItemsRequest', this.onValidateCartItemRequestEvent.bind(this))
		document.addEventListener('validateCartItemsSuccess', this.onValidateCartItemSuccessEvent.bind(this))
		document.addEventListener('validateCartItemsFailed', this.onValidateCartItemFailedEvent.bind(this));
		document.addEventListener('cartItemsRemoved', this.onCartItemsRemovedEvent.bind(this));
	}

	/**
	 * Set renderer. Will perform a handshake between validator and renderer.
	 *
	 * @param renderer
	 */
	setRenderer(renderer) {
		this.renderer = renderer;
		this.renderer.setValidator(this).setCartStorage(this.cart);
		return this;
	}

	/**
	 * Check if validator has a renderer attached
	 *
	 * @returns {boolean}
	 */
	hasRenderer() {
		return !!this.renderer;
	}

	/**
	 * Get cart data from localForage and cache it locally.
	 */
	cacheCartData() {
		this.setCacheCartData(getCartItemsFromStorage())
	}

	/**
	 * Set cart object to work with
	 *
	 * @param {CartStorage} cart
	 */
	setCart(cart) {
		this.cart = cart;
		return this;
	}

	/**
	 * Set cart data
	 *
	 * @param data
	 */
	setCacheCartData(data) {
		this.cartData = data;
		this.validateCartData();
	}

	/**
	 * Build request data
	 *
	 * @returns {{items: {}}}
	 */
	buildCartValidationRequest()
	{
		const requestBuilder = new CartValidationRequest(this.cartData);
		return requestBuilder.buildRequest();
	}

	/**
	 * Sent cart data for validation
	 */
	validateCartData(params = {}) {
		dispatchValidateCartItems(params);
		// const data = Object.assign(params, this.buildCartValidationRequest());
		//
		// this.beforeRequest();
		//
		// api.public.checkout.validate(data).then(response => {
		// 	this.afterRequest(response, params);
		// 	this.handleValidationResponse(response.data.data);
		// }).catch(() => {
		//
		// });
		// .catch(error => this.handleValidationError(error));
	}

	onValidateCartItemRequestEvent() {
		$('#check-out-container').css('opacity', 0.5);
	}

	onValidateCartItemSuccessEvent(event) {
		if(event.detail){
			const {params, cartItems, response} = event.detail;
			this.afterRequest(response, params);
			this.handleValidationResponse(cartItems);
			$('#check-out-container').css('opacity', 1);
		}else {
			this.handleValidationResponse([]);
		}
	}

	onValidateCartItemFailedEvent() {
		const noCartItemSection = document.getElementById('noCartItemSection');
		if(noCartItemSection.classList.contains('d-none')){
			noCartItemSection.classList.toggle('d-none');
			$('#check-out-container').css('opacity', 1);
		}
	}

	onCartItemsRemovedEvent() {
		this.validateCartData();
	}

	/**
	 * @param error
	 */
	handleValidationError(error) {
		this.notifier.error(error.response.data.message);
		if (
			this.hasRenderer() &&
			this.renderer.handleCartValidationError !== undefined &&
			typeof this.renderer.handleCartValidationError === 'function'
		) {
			this.renderer.handleCartValidationError();
		}
	}

	/**
	 * Hook allowing to define custom functionality to run before request execution.
	 */
	beforeRequest() {}

	/**
	 * Method will be fired after request
	 */
	afterRequest() {}

	/**
	 * Handle cart validation response
	 *
	 * @param response
	 */
	handleValidationResponse(response) {
		return response;
	}
}

export default BaseCheckoutItemsValidator;
